export default "__VITE_ASSET__cb50f386__"